"use client"

import { useState, useEffect } from "react"
import { useApp } from "../../contexts/AppContext"
import Modal from "./Modal"
import { BiCheckCircle, BiX } from "react-icons/bi"

const ICONS = [
    "file-text",
    "table",
    "graph-up",
    "person",
    "building",
    "calendar",
    "clock",
    "envelope",
    "telephone",
    "geo-alt",
    "star",
    "heart",
    "bookmark",
    "tag",
    "flag",
    "camera",
    "image",
    "music-note",
]

export default function FeuilleModal({ isOpen, onClose, classeurId, feuilleId = null }) {
    const { getFeuille, addFeuilleAPI, updateFeuilleAPI } = useApp()

    const [formData, setFormData] = useState({
        code_classeur: classeurId,
        nom_feuille: "",
        libelle_feuille: "",
        nb_ligne_impr: 0,
        icone: "nothing",
        note: "",
        source_donnees: "Oui",
        statut: 1,
        date_insertion: new Date().toISOString(),
        colonnes: [],
    })

    const [errors, setErrors] = useState({})
    const isEdit = Boolean(feuilleId)


    useEffect(() => {
        if (isEdit && feuilleId) {
            const feuille = getFeuille(feuilleId)
            if (feuille) {
                setFormData(feuille)
            }
        } else {
            setFormData({
                code_classeur: classeurId,
                nom_feuille: "",
                libelle_feuille: "",
                nb_ligne_impr: 0,
                icone: "nothing",
                note: "",
                source_donnees: "Oui",
                statut: 1,
                date_insertion: new Date().toISOString(),
                colonnes: [],
            })
        }
        setErrors({})
    }, [feuilleId, classeurId, isEdit, isOpen])


    const validateForm = () => {
        const newErrors = {}

        if (!formData.nom_feuille.trim()) {
            newErrors.nom_feuille = "Le nom est obligatoire"
        }

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }


    const handleSubmit = (e) => {
        e.preventDefault()

        if (!validateForm()) return

        if (isEdit) {
            updateFeuilleAPI(feuilleId, formData)
        } else {
            addFeuilleAPI(formData)
        }
        onClose()
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData({ ...formData, [name]: value })

        if (errors[name] && value.trim()) {
            setErrors({ ...errors, [name]: undefined })
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={isEdit ? "Modifier la feuille" : "Nouvelle feuille"} size="lg">
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="nom_feuille" className="form-label"> Nom * </label>
                    <input
                        type="text"
                        className={`form-control ${errors.nom_feuille ? "is-invalid" : ""}`}
                        id="nom_feuille"
                        name="nom_feuille"
                        value={formData.nom_feuille}
                        onChange={handleChange}
                        placeholder="Nom de la feuille"
                    />
                    {errors.nom_feuille && <div className="invalid-feedback">{errors.nom_feuille}</div>}
                </div>

                <div className="mb-3">
                    <label htmlFor="libelle_feuille" className="form-label"> Description </label>
                    <textarea
                        className="form-control"
                        id="libelle_feuille"
                        name="libelle_feuille"
                        rows="2"
                        value={formData.libelle_feuille}
                        onChange={handleChange}
                        placeholder="Description de la feuille"
                    />
                </div>

                <div className="row">
                    <div className="col-md-3">
                        <div className="mb-3">
                            <label htmlFor="nb_ligne_impr" className="form-label"> Nbre de lignes </label>
                            <input
                                type="number"
                                className="form-control"
                                id="nb_ligne_impr"
                                name="nb_ligne_impr"
                                min="0"
                                max="100"
                                step="1"
                                value={formData.nb_ligne_impr}
                                onChange={handleChange}
                                placeholder="Nombre de lignes imprimées"
                            />
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="mb-3">
                            <label htmlFor="icone" className="form-label"> Icône </label>
                            <select className="form-select" id="icone" name="icone" value={formData.icone} onChange={handleChange}>
                                {ICONS.map((icon) => (
                                    <option key={icon} value={icon}>
                                        {icon}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="mb-3">
                            <label htmlFor="source_donnees" className="form-label"> Source des données </label>
                            <select className="form-select" id="source_donnees" name="source_donnees" value={formData.source_donnees} onChange={handleChange}>
                                <option value="Oui">Oui</option>
                                <option value="Non">Non</option>
                            </select>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="mb-3">
                            <label htmlFor="statut" className="form-label"> Statut </label>
                            <select className="form-select" id="statut" name="statut" value={formData.statut} onChange={handleChange}>
                                <option value="1">Actif</option>
                                <option value="0">Inactif</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="mb-3">
                    <label htmlFor="note" className="form-label"> Note </label>
                    <textarea
                        className="form-control w-100"
                        id="note"
                        name="note"
                        rows="2"
                        value={formData.note}
                        onChange={handleChange}
                        placeholder="Note"
                    />
                </div>

                <div className="d-flex justify-content-between gap-2 mt-3">
                    <button type="button" className="btn btn-sm btn-secondary btn-sm px-2 d-flex align-items-center" onClick={onClose}>
                        <BiX className="me-1" /> Annuler </button>
                    <button type="submit" className="btn btn-sm btn-primary btn-sm px-2 d-flex align-items-center">
                        <BiCheckCircle className="me-1" /> {isEdit ? "Modifier" : "Ajouter"}
                    </button>
                </div>
            </form>
        </Modal>
    )
}
